import React from "react";
import { motion } from "../components/StaticMotion";
import { HoverCard, HoverIcon } from "../components/HoverMotion";
import { FaEye, FaRocket } from "react-icons/fa";

const cardVariants = {
  hidden: { opacity: 0, y: 25, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.6, ease: "easeOut" } },
};

export const SectionVisionMission = () => {
  const missionItems = [
    "Build scalable, reliable event technology that organizers can count on",
    "Deliver the best real-time experiences for participants and spectators",
    "Support the sustainable growth of Indonesia's sports and event industry",
    "Continuously innovate to stay ahead of evolving event management needs",
  ];

  return (
    <section id="vision-mission" className="w-full py-16 lg:py-24 px-4 bg-slate-50 overflow-hidden">
      <motion.div
        className="w-full max-w-6xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center mb-10">
          <motion.h2
            className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Vision & Mission
          </motion.h2>
          <motion.p
            className="text-gray-600 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            Rooted in a commitment to digital excellence, we are driven by a clear purpose: to make every event smarter, safer, and more impactful — for organizers and participants alike.
          </motion.p>
        </div>

        <motion.div
          className="grid grid-cols-1 lg:grid-cols-2 gap-4"
          variants={{ visible: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } } }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Vision Card */}
          <motion.div variants={cardVariants}>
            <HoverCard className="bg-white border border-slate-200 p-4 h-full flex items-start gap-4 rounded-card">
              <HoverIcon className="w-10 h-10 bg-slate-100 border border-slate-200 flex items-center justify-center flex-shrink-0 rounded-icon text-slate-700">
                <FaEye className="w-5 h-5" />
              </HoverIcon>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-slate-900 mb-1">Vision</h3>
                <p className="text-sm text-slate-600 leading-relaxed">
                  To become the leading event technology platform in Southeast Asia — empowering every race, competition, and gathering with precision, transparency, and seamless digital infrastructure.
                </p>
              </div>
            </HoverCard>
          </motion.div>

          {/* Mission Card */}
          <motion.div variants={cardVariants}>
            <HoverCard className="bg-slate-900 border border-slate-200 p-4 h-full flex items-start gap-4 rounded-card">
              <HoverIcon className="w-10 h-10 bg-white/10 border border-white/20 flex items-center justify-center flex-shrink-0 rounded-icon text-white">
                <FaRocket className="w-5 h-5" />
              </HoverIcon>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-white mb-1">Mission</h3>
                <ul className="space-y-2">
                  {missionItems.map((item, index) => (
                    <li key={index} className="flex items-start gap-2 text-slate-300 text-sm leading-relaxed">
                      <span className="w-1.5 h-1.5 bg-slate-400 rounded-full mt-1.5 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </HoverCard>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};
